import React from 'react';
import { Badge } from './badge';
import { Button } from './button';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Background images for different page categories
export const heroBackgrounds = {
  // Services
  'equipment-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/svn79pbk_Screenshot%202026-01-19%20at%2012.20.33%E2%80%AFPM.png',
  'protective-coatings': 'https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'pipeline-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/wjcd704e_Screenshot%202026-01-19%20at%2012.07.14%E2%80%AFPM.png',
  'structural-repair': 'https://images.pexels.com/photos/30685883/pexels-photo-30685883.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'hvac-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/14x8mp2j_Screenshot%202026-01-19%20at%2012.12.51%E2%80%AFPM.png',
  'industrial-cleaning': 'https://images.pexels.com/photos/8774639/pexels-photo-8774639.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'tank-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/5rrnwyfa_Screenshot%202026-01-19%20at%2012.19.05%E2%80%AFPM.png',
  'grease-interceptors': '/grease-interceptor/hero.png',
  'roof-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/xo6hy9o2_Screenshot%202026-01-19%20at%2012.30.54%E2%80%AFPM.png',
  'floor-repair': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/9yo82g0w_Screenshot%202026-01-19%20at%2012.24.17%E2%80%AFPM.png',
  'asset-life-extension': 'https://images.pexels.com/photos/36311180/pexels-photo-36311180.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'engines-casings': 'https://images.pexels.com/photos/633850/machine-mill-industry-steam-633850.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'fans-blowers': 'https://images.pexels.com/photos/416423/pexels-photo-416423.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'gaskets-seals': 'https://images.pexels.com/photos/19895875/pexels-photo-19895875.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'marine-offshore': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/kwyyjo3u_Screenshot%202026-01-19%20at%2012.11.25%E2%80%AFPM.png',
  'mechanical-transmission': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/6ubx19z8_Screenshot%202026-01-19%20at%2012.16.27%E2%80%AFPM.png',
  'solids-handling': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/htqbrsl9_Screenshot%202026-01-19%20at%2012.10.03%E2%80%AFPM.png',
  
  // Industries
  'manufacturing': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/1llpd3rd_Screenshot%202026-01-19%20at%201.38.39%E2%80%AFPM.png',
  'oil-and-gas': 'https://images.pexels.com/photos/15970032/pexels-photo-15970032.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'power': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/nv9nrw0j_Screenshot%202026-01-19%20at%2012.24.55%E2%80%AFPM.png',
  'water-wastewater': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/qr7pddoo_Screenshot%202026-01-19%20at%201.36.46%E2%80%AFPM.png',
  'marine': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/3jco17fc_Screenshot%202026-01-19%20at%201.35.24%E2%80%AFPM.png',
  'petrochemical': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/x7hnt8m3_Screenshot%202026-01-19%20at%2012.36.06%E2%80%AFPM.png',
  'general-industry': 'https://images.pexels.com/photos/34718930/pexels-photo-34718930.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'wind-power': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/y6949q3c_Screenshot%202026-01-19%20at%201.40.36%E2%80%AFPM.png',
  'facilities-maintenance': 'https://images.pexels.com/photos/16368437/pexels-photo-16368437.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'food-and-drink': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/kqdaxfzb_Screenshot%202026-01-19%20at%201.39.33%E2%80%AFPM.png',
  'pharmaceutical': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/gxozv9xl_Screenshot%202026-01-19%20at%2012.45.46%E2%80%AFPM.png',
  'pulp-and-paper': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/xtjes9la_Screenshot%202026-01-19%20at%2012.40.09%E2%80%AFPM.png',
  'steel': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/6edrcfar_Screenshot%202026-01-19%20at%2012.38.59%E2%80%AFPM.png',
  'mining-quarrying': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/nfh1f012_Screenshot%202026-01-19%20at%2012.33.04%E2%80%AFPM.png',
  'sugar': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/0euhtu4u_sugar-plant-banner4.webp',
  'hydrogen': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/jmx2o555_Screenshot%202026-01-19%20at%2012.37.30%E2%80%AFPM.png',
  'waste-to-energy': 'https://images.pexels.com/photos/18416936/pexels-photo-18416936.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'education': 'https://images.pexels.com/photos/2083391/pexels-photo-2083391.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'agriculture-fishing': 'https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/bjk73n9q_Screenshot%202026-01-19%20at%2012.42.05%E2%80%AFPM.png',
  
  // Research & Learn
  'corrosion-rust': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/9l8cl0ni_Screenshot%202026-01-19%20at%202.02.19%E2%80%AFPM.png',
  'leaks-seepage': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/z1skoqbd_Screenshot%202026-01-19%20at%202.09.48%E2%80%AFPM.png',
  'erosion-wear': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/kfg1efee_217FD330-3BD7-4FE9-B219-91F14B8C64AB_1_102_o.jpeg',
  'equipment-failures': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/5l8rxgxh_Screenshot%202026-01-19%20at%202.10.39%E2%80%AFPM.png',
  'hvac-cooling': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/ia9udhkj_Screenshot%202026-01-19%20at%202.12.40%E2%80%AFPM.png',
  'structural-damage': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/7aqppb0q_Screenshot%202026-01-19%20at%202.14.14%E2%80%AFPM.png',
  
  // Maintenance
  'smart-program': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/u69wo5th_Screenshot%202026-01-19%20at%201.43.35%E2%80%AFPM.png',
  'systematic-inspections': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/od2gwmdl_Screenshot%202026-01-19%20at%201.54.51%E2%80%AFPM.png',
  'active-corrosion-control': 'https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'reliable-repair-methods': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/mo6ngx5n_Screenshot%202026-01-19%20at%201.59.33%E2%80%AFPM.png',
  'material-specific-solutions': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/hszmi0ro_Screenshot%202026-01-19%20at%201.56.36%E2%80%AFPM.png',
  'total-asset-lifecycle': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/dt5kgzpu_Screenshot%202026-01-19%20at%202.01.04%E2%80%AFPM.png',
  
  // About
  'about-company': 'https://images.pexels.com/photos/30685883/pexels-photo-30685883.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'why-choose-bcs': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/frz03t5k_Screenshot%202026-01-19%20at%202.16.12%E2%80%AFPM.png',
  'our-experience': 'https://customer-assets.emergentagent.com/job_5438d55d-6fb3-446d-bfb9-defb744855cb/artifacts/wfaj2nfh_Screenshot%202026-01-19%20at%202.24.15%E2%80%AFPM.png',
  'customer-testimonials': 'https://images.pexels.com/photos/6950015/pexels-photo-6950015.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'our-team': 'https://images.pexels.com/photos/6285146/pexels-photo-6285146.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  
  // Belzona
  'belzona': 'https://images.pexels.com/photos/29224591/pexels-photo-29224591.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  
  // Other
  'careers': 'https://images.pexels.com/photos/6950015/pexels-photo-6950015.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600',
  'default': 'https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600'
};

// Custom background positions for specific pages
const customBackgroundPositions = {
  // Add custom positions as needed
};

// Custom background sizes for specific pages
const customBackgroundSizes = {
  // Add custom sizes as needed
};

const PageHero = ({ 
  badge, 
  title, 
  description, 
  backgroundKey = 'default',
  buttonText = 'Get In Touch',
  buttonAction,
  showButton = true
}) => {
  const navigate = useNavigate();
  const backgroundImage = heroBackgrounds[backgroundKey] || heroBackgrounds.default;
  const backgroundPosition = customBackgroundPositions[backgroundKey] || 'center';
  const backgroundSize = customBackgroundSizes[backgroundKey] || 'cover';
  
  const handleButtonClick = () => {
    if (buttonAction) {
      buttonAction();
      return;
    }
    // Default: open the visitor's email client with a prefilled inquiry to info@bcs-us.com
    const subject = encodeURIComponent(title ? `Inquiry: ${title}` : 'Service Inquiry');
    const bodyText = encodeURIComponent(
      `Hi BCS team,\n\nI'd like to get in touch regarding ${title || 'your services'}.\n\n(Please share any project details or questions here.)\n\nThanks!`
    );
    window.location.href = `mailto:info@bcs-us.com?subject=${subject}&body=${bodyText}`;
    // Kept navigate for backwards compat if consumers call it through buttonAction
    void navigate;
  };

  return (
    <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 opacity-[0.25]"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: backgroundSize,
          backgroundPosition: backgroundPosition,
          backgroundRepeat: 'no-repeat',
          filter: 'sepia(40%) saturate(70%)'
        }}
      ></div>
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 via-transparent to-slate-900/70"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        {badge && (
          <Badge className="mb-4 bg-white/20 text-white border border-white/30 backdrop-blur-sm">
            {badge}
          </Badge>
        )}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 drop-shadow-lg">
          {title}
        </h1>
        <p className="text-lg md:text-xl text-slate-200 mb-8 max-w-3xl mx-auto">
          {description}
        </p>
        {showButton && (
          <Button 
            size="lg" 
            className="bg-green-500 hover:bg-green-600 text-white font-semibold shadow-lg"
            onClick={handleButtonClick}
          >
            {buttonText}
            <ArrowRight className="ml-2" size={20} />
          </Button>
        )}
      </div>
    </section>
  );
};

export default PageHero;
